<template>
<div class="bg-white marginb20 noMargin" v-for="item in data" v-show="item.items.length>3" >
	<a :href="item.clickUrl" data-scp="aapa_{{item.id}}.all" class="up pos-r dis-b">
		<img :src="item.imageUrl" alt="">
	</a>
	<a :href="item.clickUrl" data-scp="aapa_{{item.id}}.all">
		<div class="margint20">
			<!-- 滚动商品 -->
			<div class="flex-container paddingr20 paddingl10">
				<!-- 需要循环的商品 -->
				<div v-for="innerItem in item.items.slice(0, 4)"
				     class="marginl10 border marginb20"
				     style="width:100px;border-radius:2px;">

					<div class="ratio-container img-contaier" style="width:100%;">
						<img :src="innerItem.imageUrl" alt="" onerror="this.src='//image1.51tiangou.com/tgou2/img2/dum/dum_dog.png'">
					</div>
					<div class="bg-white padding10">
						<p class="text-limit1 fs-12 text-darker" v-text="innerItem.title"></p>
						<div class="flex-container left margint10">
							<p class="text-red fs-15 lh-1" v-text="'¥'+innerItem.price"></p>
							<del class="text-light fs-11 marginl10 lh-1" v-if="innerItem.originalPrice">¥{{innerItem.originalPrice}}</del>
						</div>
					</div>
				</div>
				<!-- 查看更多 -->
<!--				<div class="marginl10 bg-white border marginb20" style="width:100px;background:url('//image1.51tiangou.com/tgou2/img2/index/see_more@2x.png') center no-repeat;background-size:100% auto;border-radius:2px;">-->
<!--					<a :href="item.clickUrl" data-scp="aapa.mr">-->
<!--						<div class="ratio-container" style="width:100px;height:98px;">-->
<!--							<div class="flex-container center bottom">-->
<!--								<div class="paddingb20">-->
<!--									&lt;!&ndash; <p class="text-red borderb fs-13 paddingv10 text-center">查看更多</p>-->
<!--									<p class="text-light fs-12">see more</p> &ndash;&gt;-->
<!--								</div>-->
<!--							</div>-->
<!--						</div>-->
<!--						<div class="text-center bg-white padding10">-->
<!--							<p class="text-limit1 fs-12">&nbsp;</p>-->
<!--							<p class="text-red fs-15 text-bolder lh-1 margint10">&nbsp;</p>-->
<!--						</div>-->
<!--					</a>-->
<!--				</div>-->
			</div>
		</div>
	</a>
</div>
</template>
<style lang="scss">
	.up:after{
		position: absolute;
	    content: '';
	    width: 0;
	    height: 0;
	    bottom: 0;
	    left: 50%;
	    margin-left: -5px;
	    border-right: 10px solid transparent;
	    border-bottom: 10px solid #fff;
	    border-left: 10px solid transparent;
	}
	.noMargin:last-child{
		margin-bottom: 0;
	}
</style>
<script>
	export default{
		props:{
			data:Array
		}
	}
</script>